import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createMemberbulk, resetState } from "../../Association/features/member/memberSlice";
import { toast } from "react-toastify";

const schema = yup.object().shape({
  image: yup
    .mixed()
    .required("Excel file is required")
    .test("fileSize", "File size is too large", (value) => value && value.size <= 5000000), // Limit file size to 5MB
});

const AddNews = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    // Reset the state when the component mounts
    dispatch(resetState());
  }, [dispatch]);
  const NewsState = useSelector((state) => state.member);
  const { createdMemberbulk, isSuccess, isError, isLoading } = NewsState;
  const [imageError, setImageError] = useState("");


  const token = useSelector((state) => state.autht.token);

  useEffect(() => {
    dispatch(resetState());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error("Something Went Wrong!");
    } else if (isSuccess && createdMemberbulk) {
      toast.success("Members Added Successfully!");
      formik.resetForm(); // Reset the form after displaying success message
    }
  }, [isSuccess, isError, isLoading, createdMemberbulk, dispatch]);

  const formik = useFormik({
    initialValues: {
      image: '',
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      if (!values.image) {
        setImageError("Please select an Excel file.");
        return;
      } else {
        setImageError("");
      }

      const formData = new FormData();
      formData.append("excelFile", values.image); // Use values.image instead of 'image'
      formData.append("token", token);

      try {
        await dispatch(createMemberbulk(formData));
      } catch (error) {
        console.error("Error adding member:", error);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">Add In Bulk From Excel file Member</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <label htmlFor="image" className="form-label">
              Select Excel file
            </label>
            <input
              type="file"
              id="image"
              name="image"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={(e) => {
                formik.setFieldValue("image", e.target.files[0]); // Set formik field value for 'image'
                setImageError(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            {formik.errors.image && formik.touched.image && <div className="error">{formik.errors.image}</div>}
            {imageError && <div className="error">{imageError}</div>}
          </div>

          <button className="btn btn-success border-0 rounded-3 my-5" type="submit" disabled={isLoading}>
            {isLoading ? "Adding Member..." : "Add Member"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNews;
